// extracted by mini-css-extract-plugin
export default {"button":"add_to_folder_add_button-module__button--3965V"};